import React from 'react'
import Dashboard from '../dashboard'
import HelpView from './page'

class Help extends React.Component {
  render() {
    return <Dashboard component={<HelpView />} />
  }
}

export default Help
